import { React } from 'react';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, Typography, IconButton } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import moment from 'moment';
import styles from '../eir-cart/styles';
import priceFormatter from '../../../util/priceFormatter';

const EirOrderedItem = ({
  title,
  contractLength,
  description,
  variant,
  price,
  itemType,
  loading,
  discountedPrice,
  offerId,
  addOnId,
  portInPhoneNumber,
  portingDate,
  activationSubText,
  getClickedItem,
  afterPrice,
  openConfirmationModal,
  deleteIcon,
  cartData,
  tacticalOffers,
  equipmentId,
  isCartDoc,
}) => {
  const theme = useTheme();
  const formatedPortingDate = moment(portingDate).format('DD/MM/YYYY');

  // const confirmDelete = e => {
  //   getClickedItem(
  //     e.currentTarget.getAttribute('value'),
  //     e.currentTarget.id,
  //     addOnId,
  //     itemType,
  //     equipmentId
  //   );
  //   openConfirmationModal.enable();
  // };

  const confirmDelete = (id, itemTitle) => {
    getClickedItem(itemTitle, id, addOnId, itemType, equipmentId);
    openConfirmationModal.enable();
  };

  return !loading ? (
    <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
      <Box sx={styles(theme).itemBox} id={offerId}>
        <Box>
          <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
            <Stack direction='row'>
              <Typography
                component='p'
                variant='body1'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {title}
              </Typography>
            </Stack>

            {
              <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='baseline'
                spacing={2}
              >
                {/* <Typography variant='body2' sx={styles(theme).strikedPrice}>
                  {discountedPrice > price && priceFormatter(parseFloat(discountedPrice))}
                </Typography> */}
                <Typography
                  component='p'
                  variant={isCartDoc ? 'subtitle1' : 'body1'}
                  sx={{ color: theme.palette.primary.textColor3 }}
                >
                  {priceFormatter(parseFloat(price))}
                </Typography>
              </Stack>
            }
          </Stack>
        </Box>

        <Stack
          direction='row'
          justifyContent='space-between'
          spacing={2}
          sx={styles(theme).afterPriceContainer}
        >
          <Typography variant='body2' sx={styles(theme).contactNumber}>
            {variant}
            {!contractLength?.includes('null') && contractLength}
            {tacticalOffers && description}
            {activationSubText}
            {discountedPrice > price && afterPrice}
          </Typography>
        </Stack>

        {portInPhoneNumber && (
          <Box>
            <Stack direction='row' justifyContent='space-between' spacing={2}>
              <Typography variant='body2' sx={styles(theme).contactNumber}>
                Porting: &nbsp;
                <Typography variant='body2' sx={styles(theme).contactNumberBold}>
                  {portInPhoneNumber}
                  &nbsp;
                </Typography>
                on &nbsp;
                <Typography variant='body2' sx={styles(theme).contactNumberBold}>
                  {formatedPortingDate}
                </Typography>
              </Typography>
            </Stack>
          </Box>
        )}
      </Box>
      <Box sx={styles(theme).deleteIcon}>
        {cartData?.isActivationAvailable && deleteIcon && (
          <IconButton
            aria-label='Remove'
            sx={{ mt: '-0.55rem' }}
            onClick={() => confirmDelete(offerId, title)}
          >
            <DeleteForeverIcon
              // id={offerId}
              // value={title}
              onClick={confirmDelete}
              fontSize='small'
              sx={{
                cursor: 'pointer',
                color: theme.palette.primary.offerPromo,
                '&:hover': { color: theme.palette.secondary.asterisk },
              }}
            />
          </IconButton>
        )}
      </Box>
    </Stack>
  ) : (
    <Skeleton variant='rectangular' width='100%' height='100%' />
  );
};
export default EirOrderedItem;
